import React, { useEffect, useState } from 'react'
import FinesQuestionView from './components/FinesQuestionView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const FinesQuestion = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('fines-question', 'Renew your Vehicle Permit', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <FinesQuestionView setIsError={setIsError} />
}

export default withTranslation('common')(FinesQuestion)
